module.exports = __webpack_public_path__ + "static/img/beijing.1783997848725.png";